import MotionFade from "../../../../common/utils/MotionFade";
import {
    Absolute,
    Background,
    CMargin,
    Decoration,
    DText,
    Flex
} from "../../../../../styles/CommonStyles";
import Text from "../../../../../core/utils/Text";
import Input from "../../../../common/input/Input";
import useAffiliateSetting from "../../../../../core/hooks/main/setting/general/useAffiliateSetting";
import ABActionButton from "../ABActionButton";
import { useWindowSize } from "../../../../../core/hooks/common/useWindowSize";
import { MOBILE_SIZE } from "../../../../../core/constants/common";

const AffiliateSetting = () => {
    const { width } = useWindowSize();

    const {
        affiliateData,
        onInputValueChange,
        loading,
        detailsChanged,
        onSubmitClicked
    } = useAffiliateSetting();

    return (
        <MotionFade>
            <CMargin margin={'30px'} />

            <Flex fw justify={'flex-start'}>
                <Decoration />

                <DText main>
                    <Text tid={'affiliate-setting-note'} />
                </DText>
            </Flex>

            <CMargin margin={'20px'} />

            <Flex fw wrap justify={'space-around'}>
                <Background bg={'mainBg'}>

                    {/* P2P */}
                    <Input
                        value={affiliateData?.p2pPercent}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'p2pPercent')
                        }
                        label={'p2p-percent'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.p2pPercentMin}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'p2pPercentMin')
                        }
                        label={'p2p-percent-min'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.p2pPercentMax}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'p2pPercentMax')
                        }
                        label={'p2p-percent-max'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    {/* OTC */}
                    <Input
                        value={affiliateData?.otcPercent}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'otcPercent')
                        }
                        label={'otc-percent'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.otcPercentMin}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'otcPercentMin')
                        }
                        label={'otc-percent-min'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.otcPercentMax}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'otcPercentMax')
                        }
                        label={'otc-percent-max'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    {/* Internal Transfer */}
                    <Input
                        value={affiliateData?.internalTransferPercent}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'internalTransferPercent')
                        }
                        label={'internalTransferPercent'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.internalTransferPercentMin}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'internalTransferPercentMin')
                        }
                        label={'internalTransferPercentMin'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.internalTransferPercentMax}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'internalTransferPercentMax')
                        }
                        label={'internalTransferPercentMax'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    {/* Swap */}
                    <Input
                        value={affiliateData?.swapPercent}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'swapPercent')
                        }
                        label={'swap-percent'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.swapPercentMin}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'swapPercentMin')
                        }
                        label={'swap-percent-min'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.swapPercentMax}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'swapPercentMax')
                        }
                        label={'swap-percent-max'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    {/* Card */}
                    <Input
                        value={affiliateData?.cardPercent}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'cardPercent')
                        }
                        label={'card-percent'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.cardPercentMin}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'cardPercentMin')
                        }
                        label={'card-percent-min'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                    <Input
                        value={affiliateData?.cardPercentMax}
                        onInputChange={(v) =>
                            onInputValueChange(v, 'cardPercentMax')
                        }
                        label={'card-percent-max'}
                        width={'30%'}
                        minWidth={'300px'}
                        number
                    />

                </Background>
            </Flex>

            {width > MOBILE_SIZE ? (
                <ABActionButton
                    show={detailsChanged}
                    onClick={onSubmitClicked}
                    loading={loading}
                />
            ) : (
                <Absolute
                    style={{ position: 'fixed' }}
                    left={0}
                    bottom={0}
                    height={'60px'}
                >
                    <ABActionButton
                        show={detailsChanged}
                        onClick={onSubmitClicked}
                        loading={loading}
                    />
                </Absolute>
            )}
        </MotionFade>
    );
};

export default AffiliateSetting;